const ENV_DEV = 'DEV'
const ENV_LIVE = 'LIVE'

const FORCE_ENV = ENV_DEV

const ENV_OVERRIDE_STORAGE_KEY = 'fg-env-override'

const DEV_DOMAIN_LIST = [
    /localhost/,
    /127.0.0.1/,
    /fg-dev/,
    /fg-uat/,
    /fg-qa/
]

function IsDevDomain() {
    if (typeof window === 'undefined') return false
    return DEV_DOMAIN_LIST.some(domain => domain.test(window.location.host))
}

function GetRuntimeEnvOverride() {
    if (typeof window === 'undefined') return null
    try {
        const stored = window.localStorage.getItem(ENV_OVERRIDE_STORAGE_KEY)
        if (stored === ENV_DEV || stored === ENV_LIVE) {
            return stored
        }
    } catch (e) {}
    return null
}

function SetRuntimeEnvOverride(env) {
    if (typeof window === 'undefined') return
    try {
        if (env === null) {
            window.localStorage.removeItem(ENV_OVERRIDE_STORAGE_KEY)
        } else if (env === ENV_DEV || env === ENV_LIVE) {
            window.localStorage.setItem(ENV_OVERRIDE_STORAGE_KEY, env)
        }
    } catch (e) {}
}

function ResolveEnv() {
    if (FORCE_ENV) return FORCE_ENV

    // Runtime override (only honored on dev-capable domains)
    if (IsDevDomain()) {
        const override = GetRuntimeEnvOverride()
        if (override) return override
    }
    return /localhost/.test(window.location.href) ? ENV_DEV : ENV_LIVE
}

const ENV = ResolveEnv()

function IsForceEnv() {
    return !!FORCE_ENV
}

function MemberCall() {
    return ENV === ENV_DEV ? 'member-calls2-dev' : 'member-calls2'
}

function MemberCalls2(forceLive = false) {
    return ENV === ENV_DEV && forceLive === false ? 'member-calls2-dev' : 'member-calls2'
}

function MemberCalls2Dev() {
    return 'member-calls2-dev'
}

function Hydra() {
    return ENV === ENV_DEV ? 'https://hydraqa.unicity.net/v5a-test' : 'https://hydra.unicity.net/v5a'
}

function HydraV6() {
    return ENV === ENV_DEV ? 'https://hydraqa.unicity.net/v6-test' : 'https://hydra.unicity.net/v6'
}

function GetMemberCalls2UrlFromDomain() {
    if (IsDevDomain()) {
        return 'https://member-calls2-dev.unicity.com'
    } else {
        return 'https://member-calls2.unicity.com'
    }
}

function HasRuntimeOverride() {
    return GetRuntimeEnvOverride() !== null
}

export const ServerEnv = {
    MemberCall,
    MemberCalls2,
    MemberCalls2Dev,
    Hydra,
    HydraV6,
    ENV,
    FORCE_ENV,
    IsDev: () => ENV === ENV_DEV,
    IsLive: () => ENV === ENV_LIVE,
    GetMemberCalls2UrlFromDomain,
    IsDevDomain,
    DEV_DOMAIN_LIST,
    GetRuntimeEnvOverride,
    SetRuntimeEnvOverride,
    HasRuntimeOverride,
    ENV_DEV,
    ENV_LIVE
}
